import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { authAPI } from '../api';
import { initApp, reloadApp, resetAppState } from './appSlice';

const initialState = {
    telegramId: null,
    telegramUsername: null,
    id: null,
    sseId: null,
    role: null,
    isAuth: false,
    fullname: null,
    error: null,
};

function updateStorage() {
    const otherItems = ['token', 'isLightTheme', 'zoomState'];
    for (const item in localStorage) {
        if (localStorage.hasOwnProperty(item) && !otherItems.some(i => i === item)) {
            localStorage.removeItem(item)
        }
    }
}

export const fetchLogin = createAsyncThunk('auth/fetchLogin', async ({ login, password }, thunkAPI) => {
    thunkAPI.dispatch(reloadApp({}));
    const data = await authAPI.login(login, password);
    if (data.isOkay) {
        thunkAPI.dispatch(setError(null));
        thunkAPI.dispatch(setAuthData({user: data.user, sseId: data.sseId}));
    } else {
        thunkAPI.dispatch(setError(data.message));
    }
    await thunkAPI.dispatch(initApp());
});
export const fetchMe = createAsyncThunk('auth/fetchMe', async (_, thunkAPI) => {
    const data = await authAPI.me();
    if (data.isOkay) {
        if (data.user.needUpdate) {
            updateStorage();
        }
        thunkAPI.dispatch(setAuthData({user: data.user, sseId: data.sseId}));
    } else {
        thunkAPI.dispatch(setError(data.message || 'Ошибка сервера'));
    }
    return data;
});
export const fetchLogout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
    const data = await authAPI.logout();
    if (data.isOkay) {
        thunkAPI.dispatch(resetAppState());
    } else {
        console.log(data)
    }
    await thunkAPI.dispatch(initApp());
});

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthData(state, {payload}) {
            const { telegramId, role, fullname, isAuth, id, telegramUsername, needUpdate } = payload.user;
            state.telegramId = telegramId;
            state.telegramUsername = telegramUsername;
            state.id = id;
            state.sseId = payload.sseId;
            state.role = role;
            state.isAuth = true;
            state.fullname = fullname;
        },
        clearAuthData(state) {
            state.telegramId = null;
            state.telegramUsername = null;
            state.id = null;
            state.sseId = null;
            state.role = null;
            state.isAuth = false;
            state.fullname = null;
        },
        setError(state, action) {
            state.error = action.payload;
        },
        updatePermissions(state, {payload}) {
            state.role.permissions = payload;
        }
    },
    extraReducers: (builder) => {
        
    },
});

export const { setAuthData, clearAuthData, setError, updatePermissions } = authSlice.actions;

export default authSlice.reducer;
